import React, { Component } from "react";

import { checkUserRunningOrder, updateUserInfo, checkBan } from "../../../services/user/actions";

import BackWithSearch from "../../Mobile/Elements/BackWithSearch";
import BillDetails from "./BillDetails";
import CartCheckoutBlock from "./CartCheckoutBlock";
import CartItems from "./CartItems";
import Coupon from "./Coupon";
import DelayLink from "../../helpers/delayLink";
import Ink from "react-ink";
import Meta from "../../helpers/meta";
import OrderComment from "./OrderComment";
import { Navigate } from "react-router-dom";
import RestaurantInfoCart from "./RestaurantInfoCart";
import { calculateDistance } from "../../helpers/calculateDistance";
import calculateDistanceGoogle from "../../helpers/calculateDistanceGoogle.js";
import { connect } from "react-redux";
import { getRestaurantInfoById, getRestaurantInfoAndOperationalStatus } from "../../../services/items/actions";
import { updateCart } from "../../../services/total/actions";
import { formatPrice } from "../../helpers/formatPrice";
import { addProduct } from "../../../services/cart/actions";

import { checkCartItemsAvailability } from "../../../services/confirmCart/actions";
import { GoogleApiWrapper } from "google-maps-react";
import Loading from "../../helpers/loading";
import UserBan from "../UserBan";
import { removeCoupon } from "../../../services/coupon/actions";
import {Flip} from "react-awesome-reveal";
import OrderScheduling from "../Modules/OrderScheduling";
import withRouter from "../../../withRouter";

class Cart extends Component {
	cartInitialized = false;

	state = {
		loading: true,
		alreadyRunningOrders: false,
		is_operational_loading: true,
		is_operational: true,
		distance: 0,
		is_active: false,
		min_order_satisfied: false,
		process_cart_loading: false,
		is_all_items_available: false,
		process_distance_calc_loading: false,
		userBan: false,
		tips: [],
		tips_percentage: [],
		tipsPercentageSetting: false,
		tipsAmountSetting: false,
		others: false,
		percentage: false,
		selectedTips: {
			type: "amount",
			value: 0,
		},
		is_tips_show: true,
	};

	componentDidMount() {
		localStorage.removeItem("cart_tips");
		localStorage.removeItem("fromCart");

		const { user } = this.props;

		const boot = async () => {
			await this.hydrateTips();
			await this.cartOperationalSteps();
		};

		if (user?.success) {
			this.props.checkBan(user.data.auth_token).then((response) => {
			if (response?.success) {
				boot();
			} else {
				this.setState({ userBan: true, loading: false });
			}
			});
		} else {
			 boot();
		}
	}


	hydrateTips = () => {
	this.setState({
		tips: localStorage.getItem("tips")?.split(",") || [],
		tips_percentage: localStorage.getItem("tips_percentage")?.split(",") || [],
		tipsAmountSetting: JSON.parse(localStorage.getItem("showTipsAmount") || "false"),
		tipsPercentageSetting: JSON.parse(localStorage.getItem("showTipsPercentage") || "false"),
		is_tips_show: localStorage.getItem("userSelected") === "SELFPICKUP",
	});
	};

	resolveUserLocation = () => {
		const { user } = this.props;

		if (user?.success && user?.data?.default_address) {
			return {
			lat: user.data.default_address.latitude,
			lng: user.data.default_address.longitude,
			};
		}

		const cached = localStorage.getItem("userSetAddress");
		if (cached) return JSON.parse(cached);

		return null;
	};


	cartInitialized = false;

	cartOperationalSteps = async () => {
		if (this.cartInitialized) return;
		this.cartInitialized = true;

		const { user, cartProducts } = this.props;

		this.setState({ loading: false });

		// UI + stock validation
		if (cartProducts.length) {
			document.body.classList.add("bg-grey");
			this.checkForItemsAvailability();
		}

		const activeRestaurantId = this.resolveActiveRestaurantId();

		// ✅ Guest flow (NO USER)
		if (!user?.success) {
			this.setState({ alreadyRunningOrders: false });

			if (activeRestaurantId && cartProducts.length > 0) {
			const response = await this.props.getRestaurantInfoById(activeRestaurantId);
			const restaurant = response?.payload;

			if (restaurant?.id) {
				const location = this.resolveUserLocation();

				if (location) {
				this.__doesRestaurantOperatesAtThisLocation(restaurant, location);
				} else {
				this.setState({
					is_operational: true,
					is_operational_loading: false,
				});
				}
			}
			}

			return;
		}

		// ✅ AUTH USER FLOW
		this.props.checkUserRunningOrder(user.data.id, user.data.auth_token);

		if (!cartProducts.length) return;

		// const updatedUser = await this.props.updateUserInfo(
		// 	user.data.id,
		// 	user.data.auth_token
		// );

		// if (!updatedUser?.payload?.data) {
		// 	console.warn("Failed to update user info");
		// 	return;
		// }

		const address = user.data.default_address;

		if (address) {
			const userSetAddress = {
			lat: address.latitude,
			lng: address.longitude,
			address: address.address,
			house: address.house,
			tag: address.tag,
			};

			localStorage.setItem("userSetAddress", JSON.stringify(userSetAddress));
		}

		let restaurant = this.props.restaurant_info;

		if (!restaurant?.id && activeRestaurantId) {
			const restaurantResponse = await this.props.getRestaurantInfoById(
			activeRestaurantId
			);
			restaurant = restaurantResponse?.payload;
		}

		const location = this.resolveUserLocation();

		if (restaurant?.id && location) {
			this.__doesRestaurantOperatesAtThisLocation(restaurant, location);
		} else {
			this.setState({
			is_operational: true,
			is_operational_loading: false,
			});
		}
	};


	componentDidUpdate(prevProps) {
		if (
			prevProps.restaurant_info !== this.props.restaurant_info &&
			this.props.restaurant_info?.id
		) {
			this.__isRestaurantActive(this.props.restaurant_info);
			this.__checkMinOrderSatisfied(
			this.props.restaurant_info,
			this.props.cartTotal
			);
			// Store restaurant info for back navigation from checkout and mismatch detection
			if (this.props.restaurant_info?.slug) {
				localStorage.setItem("activeRestaurantSlug", this.props.restaurant_info.slug);
				localStorage.setItem("activeRestaurantName", this.props.restaurant_info.name || "");
				localStorage.setItem("activeRestaurantImage", this.props.restaurant_info.image || "");
			}
		}

		if (prevProps.cartTotal.totalPrice !== this.props.cartTotal.totalPrice && this.props.restaurant_info?.id) {
			this.__checkMinOrderSatisfied(
				this.props.restaurant_info,
				this.props.cartTotal
			);
		}

		if (
			!prevProps.force_reload &&
			this.props.force_reload
		) {
			window.location.reload();
		}
	}


	addProductQuantity = (product) => {
		const { cartProducts, updateCart } = this.props;

			const index = cartProducts.findIndex(
				(p) => p.id === product.id && JSON.stringify(p) === JSON.stringify(product)
			);
			if (index >= 0) {
				cartProducts.forEach((cp) => {
					if (cp.id === product.id) {
						if (JSON.stringify(cp) === JSON.stringify(product)) {
								cp.quantity += 1;
					}
					}
				});

				updateCart(cartProducts);
				this.props.removeCoupon();
		}
	}


	removeProductQuantity = (product) => {
		const { cartProducts, updateCart } = this.props;

		const index = cartProducts.findIndex(
			(p) => p.id === product.id && JSON.stringify(p) === JSON.stringify(product)
		);
		//if product is in the cart then index will be greater than 0
		if (index >= 0) {
			cartProducts.forEach((cp) => {
				if (cp.id === product.id) {
					if (JSON.stringify(cp) === JSON.stringify(product)) {
						if (cp.quantity === 1) {
							//if quantity is 1 then remove product from cart
							cartProducts.splice(index, 1);
						} else {
							//else decrement the quantity by 1
							cp.quantity -= 1;
						}
					}
				}
			});

			updateCart(cartProducts);
			this.props.removeCoupon();
			this.checkForItemsAvailability();

		}
	};

	removeProduct = (product) => {
		// console.log(product);
		// console.log(product.id);

		const { cartProducts, updateCart } = this.props;
		const index = cartProducts.findIndex((cp) => cp.id === product.id);

		// console.log(index);
		cartProducts.splice(index, 1);
		// console.log(cartProducts);
		updateCart(cartProducts);
		this.props.removeCoupon();
		this.checkForItemsAvailability();
	};

	__doesRestaurantOperatesAtThisLocation = (restaurant, location) => {
		if (!restaurant?.id || !location?.lat || !location?.lng) {
			console.warn("Missing restaurant or location");
			this.setState({ is_operational: true, is_operational_loading: false });
			return;
		}

		this.setState({ process_distance_calc_loading: true });

		const finalize = (distance) => {
			this.setState(
				{ distance, process_distance_calc_loading: false },
				() => {
					this.__processRestaurantOperationalState(
					restaurant.id,
					location.lat,
					location.lng
					);
				}
			);
		};

		if (localStorage.getItem("enGDMA") === "true") {
			calculateDistanceGoogle(
			restaurant.longitude,
			restaurant.latitude,
			location.lng,
			location.lat,
			this.props.google,
			finalize
			);
		} else {
			const distance = calculateDistance(
			restaurant.longitude,
			restaurant.latitude,
			location.lng,
			location.lat
			);
			finalize(distance);
		}
	};

	__processRestaurantOperationalState = async (id, lat, lng) => {
		if (!id || !lat || !lng) {
			console.warn("Invalid operational params");
			this.setState({ is_operational: true, is_operational_loading: false });
			return;
		}

		const response = await this.props.getRestaurantInfoAndOperationalStatus(id, lat, lng);

		if (!response?.payload) return;

		this.setState({
			is_operational: Boolean(response.payload.is_operational),
			is_operational_loading: false,
		});
	};


	__isRestaurantActive = (restaurant_info) => {
		if (restaurant_info.is_active) {
			this.setState({
				is_active: true,
			});
		}
	};

	__checkMinOrderSatisfied = (restaurant_info, cartTotal) => {
		if (restaurant_info.min_order_price > 0) {
			//if not null, then check the min order price with the order total
			const totalPrice = parseFloat(formatPrice(cartTotal.totalPrice));
			const minOrderPrice = parseFloat(formatPrice(restaurant_info.min_order_price));
			if (totalPrice >= minOrderPrice) {
				// console.log("Order Can Be Placed", totalPrice + " -- " + minOrderPrice);
				this.setState({ min_order_satisfied: true });
			} else {
				// console.log("Order CANNOT Be Placed", totalPrice + " -- " + minOrderPrice);
				this.setState({ min_order_satisfied: false });
			}
		} else {
			// if null, then set to satisfied to true...
			// console.log("Min order price is not set");
			this.setState({ min_order_satisfied: true });
		}
	};

	checkForItemsAvailability = () => {
		const { checkCartItemsAvailability, cartProducts, addProduct, updateCart } = this.props;
		this.handleProcessCartLoading(true);
		checkCartItemsAvailability(cartProducts).then((response) => {
			this.handleProcessCartLoading(false);
			this.setState({ process_cart_loading: false });
			if (response && response.length) {
				let isSomeInactive = false;
				response.map((arrItem) => {
					//find the item in the cart
					let item = cartProducts.find((item) => item.id === arrItem.id);

					//get new price and is_active status and set it.
					item.is_active = arrItem.is_active;
					item.price = arrItem.price;
					addProduct(item);

					if (!isSomeInactive) {
						if (!arrItem.is_active) {
							isSomeInactive = true;
						}
					}
					return item;
				});
				if (isSomeInactive) {
					this.handleItemsAvailability(false);
				} else {
					this.handleItemsAvailability(true);
				}
			}
			updateCart(this.props.cartProducts);
		});
	};

	handleProcessCartLoading = (value) => {
		this.setState({ process_cart_loading: value });
	};

	handleItemsAvailability = (value) => {
		this.setState({ is_all_items_available: value });
	};

	showOtherText = (type) => {
		localStorage.setItem("cart_tips", JSON.stringify({ type: type, value: 0 }));
		this.setState({
			others: type === "total",
			percentage: type === "percentage",
			selectedTips: { type: type, value: 0 },
		});
	};
	addTip = (type, value) => {
		localStorage.setItem("cart_tips", JSON.stringify({ type: type, value: value }));
		//localStorage.setItem("cart_tips", JSON.stringify({ type : value});
		this.setState({ others: false, percentage: false, selectedTips: { type: type, value: value } });
	};
	addTipInPercentage = (type, value) => {
		let calculatedValue = (this.props.cartTotal.totalPrice * value) / 100;
		localStorage.setItem("cart_tips", JSON.stringify({ type: type, value: calculatedValue }));
		//localStorage.setItem("cart_tips", JSON.stringify({ type : value});
		this.setState({ others: false, percentage: false, selectedTips: { type: type, value: calculatedValue } });
	};
	// onInputchange = (event) => {
	// 	this.setState({
	// 		[event.target.name]: event.target.value,
	// 		selectedTips: { type: event.target.name, value: event.target.value },
	// 	});
	// 	// localStorage.setItem("orderComment", event.target.value);
	// };
	restrictAlphabates = (e) => {
		const re = /^[0-9\b]+$/;
		// let value = e.target.value;
		let { value, min, max } = e.target;
		value = Math.max(Number(min), Math.min(Number(max), Number(value)));

		if (e.target.value === "" || re.test(e.target.value)) {
			if (e.target.name === "percentageValue" && value !== "") {
				let calculatedValue = (this.props.cartTotal.totalPrice * value) / 100;
				localStorage.setItem("cart_tips", JSON.stringify({ type: "percentage", value: calculatedValue }));
				this.setState({
					[e.target.name]: value,
					selectedTips: { type: e.target.name, value: calculatedValue },
				});
			}
			if (e.target.name === "flatAmount" && value !== "") {
				localStorage.setItem("cart_tips", JSON.stringify({ type: "total", value: value }));
				this.setState({
					[e.target.name]: value,
					selectedTips: { type: e.target.name, value: value },
				});
			}
		}

		this.setState({ value });
	};

	removeTip = () => {
		this.setState({ others: false, percentage: false, selectedTips: { type: "amount", value: 0 } });
		localStorage.removeItem("cart_tips");

		this.setState({ tipsAmountSetting: false, tipsPercentageSetting: false }, () => {
			this.setState({
				tipsAmountSetting: JSON.parse(localStorage.getItem("showTipsAmount").toLowerCase()),
				tipsPercentageSetting: JSON.parse(localStorage.getItem("showTipsPercentage").toLowerCase()),
			});
		});
	};
	
	resolveActiveRestaurantId = () => {
		const { restaurant_info, cartProducts } = this.props;

		if (restaurant_info?.id) return restaurant_info.id;

		const fromStorage = localStorage.getItem("activeRestaurant");
		if (fromStorage) return Number(fromStorage);

		if (cartProducts.length && cartProducts[0]?.restaurant_id) {
			localStorage.setItem("activeRestaurant", cartProducts[0].restaurant_id);
			return cartProducts[0].restaurant_id;
		}

		return null;
	};

	componentWillUnmount() {
		document.getElementsByTagName("body")[0].classList.remove("bg-grey");
		//if cart not confirmed, then remove tip
		if (!this.props.confirmCart) {
			localStorage.removeItem("cart_tips");
		}
	}

	render() {
		if (this.state.userBan) {
			return <UserBan />;
		}
		const isAppUrl = new URLSearchParams(window.location.search).get("app") === "1";
		const isInsidePreviewFrame = window.self !== window.top;

		if (window.innerWidth > 768 && !isAppUrl && !isInsidePreviewFrame) {
			return <Navigate to="/" />;
		}
		if (!this.props.cartProducts.length) {
			document.getElementsByTagName("body")[0].classList.remove("bg-grey");
		}
		const { cartTotal, cartProducts, restaurant_info, user } = this.props;
		const activeRestaurantId = this.resolveActiveRestaurantId();


		return (
			<React.Fragment>
				<Meta
					seotitle={localStorage.getItem("cartPageTitle")}
					seodescription={localStorage.getItem("seoMetaDescription")}
					ogtype="website"
					ogtitle={localStorage.getItem("seoOgTitle")}
					ogdescription={localStorage.getItem("seoOgDescription")}
					ogurl={window.location.href}
					twittertitle={localStorage.getItem("seoTwitterTitle")}
					twitterdescription={localStorage.getItem("seoTwitterDescription")}
				/>

				{(this.state.loading ||
					this.state.process_distance_calc_loading ||
					this.state.process_cart_loading) && (
					<div className="height-100 overlay-loading ongoing-payment-spin">
						<div className="spin-load" />
					</div>
				)}

				{!this.state.loading && (
					<React.Fragment>
						<BackWithSearch
							boxshadow={true}
							has_title={true}
							title={localStorage.getItem("cartPageTitle")}
							disable_search={true}
							homeButton={true}
							goto_store={cartProducts.length > 0}
						/>
						{cartProducts.length ? (
							<React.Fragment>
								{localStorage.getItem("customCartMessage") !== "<p><br></p>" &&
									localStorage.getItem("customCartMessage") !== "null" &&
									(localStorage.getItem("customCartMessage") !== "" && (
										<div
											style={{
												position: "relative",
												paddingTop: "4rem",
												marginBottom: "-3rem",
											}}
											dangerouslySetInnerHTML={{
												__html: localStorage.getItem("customCartMessage"),
											}}
										/>
									))}

								<RestaurantInfoCart restaurant={restaurant_info} />

								{user.success &&
								parseInt(restaurant_info.is_schedulable) === 1 &&
								parseInt(restaurant_info.accept_scheduled_orders) === 1 &&
								localStorage.getItem("enableOrderSchedulingOnCustomer") === "true" &&
								restaurant_info.schedule_data !== null &&
								this.state.is_active && <OrderScheduling restaurant={restaurant_info} />}
                
								<div className="p-15">
									<div
										className="block-content block-content-full bg-white pt-10 pb-5"
										style={{ borderTopLeftRadius: "5px", borderTopRightRadius: "5px" }}
									>
										<h2 className="item-text mb-10">
											{localStorage.getItem("cartItemsInCartText")}
										</h2>
										{cartProducts.map((item, index) => (
											<CartItems
												item={item}
												addProductQuantity={this.addProductQuantity}
												removeProductQuantity={this.removeProductQuantity}
												removeProduct={this.removeProduct}
												key={item.name + item.id + index}
											/>
										))}
									</div>
									<OrderComment />
								</div>
								{(this.state.tipsAmountSetting || this.state.tipsPercentageSetting) && (
									<div className="mx-15 mb-15 tips-block">
										{this.state.tips && this.state.is_tips_show === false && (
											<div className="block-content block-content-full bg-white pt-10 pb-5">
												<div
													className={
														!this.state.tipsAmountSetting &&
														!this.state.tipsPercentageSetting
															? "d-none"
															: "d-show"
													}
												>
													<p className="item-text mb-10">
														<strong>{localStorage.getItem("tipsForDeliveryText")}</strong>
													</p>
													<p> {localStorage.getItem("tipsThanksText")}.</p>
												</div>
												{this.state.tipsAmountSetting && (
													<div className="tip-switch-field">
														{this.state.tips.map((tipAmount, index) => (
															<div key={index} className="tips">
																<input
																	type="radio"
																	value={tipAmount}
																	id={index}
																	name="switch-two"
																	onClick={() => this.addTip("amount", tipAmount)}
																/>
																<label
																	htmlFor={index}
																	className={` ${index > 0 && "ml-5"}`}
																>
																	{localStorage.getItem("currencySymbolAlign") ===
																		"left" &&
																		localStorage.getItem("currencyFormat")}
																	{tipAmount}
																	{localStorage.getItem("currencySymbolAlign") ===
																		"right" &&
																		localStorage.getItem("currencyFormat")}
																</label>
															</div>
														))}
														<div className="tips">
															<input
																type="radio"
																value="other"
																id="others"
																name="switch-two"
																onClick={(event) => this.showOtherText("total")}
															/>
															<label htmlFor="others" className="ml-5">
																{localStorage.getItem("tipsOtherText")}
															</label>
														</div>
													</div>
												)}
												{this.state.others && (
													<input
														className="form-control custom-tip-input mb-15"
														name="flatAmount"
														type="text"
														placeholder={localStorage.getItem(
															"cartTipAmountPlaceholderText"
														)}
														value={this.state.flatAmount || ""}
														onChange={this.restrictAlphabates}
														onKeyPress={this.restrictAlphabates}
														min="0"
														max="10000"
													/>
												)}
												{this.state.tipsPercentageSetting && (
													<div className="tip-switch-field">
														{this.state.tips_percentage.map((tipPercentage, index) => (
															<div key={index} className="tips_percentage">
																<input
																	type="radio"
																	value={tipPercentage}
																	id={`${index}_tips_percentage`}
																	name="switch-two"
																	onClick={() =>
																		this.addTipInPercentage("amount", tipPercentage)
																	}
																/>
																<label
																	htmlFor={`${index}_tips_percentage`}
																	className={` ${index > 0 && "ml-5"}`}
																>
																	{" "}
																	{tipPercentage}%
																</label>
															</div>
														))}
														<div className="tips">
															<input
																type="radio"
																value="percentage"
																id="percentage"
																name="switch-two"
																onClick={() => this.showOtherText("percentage")}
															/>
															<label htmlFor="percentage" className="ml-5">
																{localStorage.getItem("tipsOtherText")}
															</label>
														</div>
													</div>
												)}
												{this.state.percentage && (
													<input
														className="form-control custom-tip-input mb-15"
														name="percentageValue"
														type="text"
														placeholder={localStorage.getItem(
															"cartTipPercentagePlaceholderText"
														)}
														value={this.state.percentageValue || ""}
														onChange={this.restrictAlphabates}
														onKeyPress={this.restrictAlphabates}
														min="0"
														max="100"
													/>
												)}
											</div>
										)}
									</div>
								)}

								<div>
									<Coupon subtotal={this.props.cartTotal.totalPrice} />
									{this.props.running_order && (
										<div className="px-15">
											<div className="ongoing-order-notify">
												<DelayLink to="/my-orders" delay={250} className="ml-2">
													{localStorage.getItem("ongoingOrderMsg")}{" "}
													<i
														className="si si-arrow-right ml-1"
														style={{
															fontSize: "0.7rem",
														}}
													/>
													<Ink duration="500" />
												</DelayLink>
											</div>
										</div>
									)}
								</div>
								<div>
									<BillDetails
										total={cartTotal.totalPrice}
										distance={this.state.distance}
										alreadyRunningOrders={this.state.alreadyRunningOrders}
										tips={this.state.selectedTips}
										removeTip={this.removeTip}
									/>
								</div>

								{this.state.is_operational_loading ? (
									<Loading />
								) : (
									<React.Fragment>
										{this.state.is_active ? (
											<React.Fragment>
												{this.state.min_order_satisfied ? (
													<React.Fragment>
														{this.state.is_all_items_available && (
															<CartCheckoutBlock
																restaurant_id={activeRestaurantId}
  																cart_page={window.location.pathname}
																is_operational_loading={
																	this.state.is_operational_loading
																}
																is_operational={this.state.is_operational}
																handleProcessCartLoading={this.handleProcessCartLoading}
																checkForItemsAvailability={
																	this.checkForItemsAvailability
																}
																handleItemsAvailability={this.handleItemsAvailability}
															/>
														)}
													</React.Fragment>
												) : (
													<div className="auth-error no-click">
														<div className="error-shake">
															{localStorage.getItem("restaurantMinOrderMessage")}{" "}
															{localStorage.getItem("currencySymbolAlign") === "left" &&
																localStorage.getItem("currencyFormat")}
															{this.props.restaurant_info.min_order_price}
															{localStorage.getItem("currencySymbolAlign") === "right" &&
																localStorage.getItem("currencyFormat")}
														</div>
													</div>
												)}
											</React.Fragment>
										) : (
											<div className="auth-error no-click">
												<div className="error-shake">
													{this.props.restaurant_info && this.props.restaurant_info.name} :{" "}
													{localStorage.getItem("notAcceptingOrdersMsg")}
												</div>
											</div>
										)}
									</React.Fragment>
								)}
							</React.Fragment>
						) : (
							<div className="bg-white cart-empty-block">
								<Flip>
									<div className="d-flex justify-content-center">
										<img
											className="cart-empty-img"
											src="/assets/img/various/cart-empty.png"
											alt={localStorage.getItem("cartEmptyText")}
										/>
									</div>
								</Flip>
								<h2 className="cart-empty-text mt-50 text-center">
									{localStorage.getItem("cartEmptyText")}
								</h2>
								<div className="text-center mt-20 mb-20">
									<DelayLink to="/my-carts" delay={200} className="btn btn-outline-secondary btn-sm">
										<i className="si si-basket mr-1" />{localStorage.getItem("savedCartsTitle") || "Saved Carts"}
									</DelayLink>
								</div>
								{this.state.alreadyRunningOrders && (
									<div
										className="ongoing-order-notify"
										style={{
											position: "fixed",
											bottom: "4.5rem",
										}}
									>
										<DelayLink to="/my-orders" delay={250} className="ml-2">
											{localStorage.getItem("ongoingOrderMsg")}{" "}
											<i className="si si-arrow-right ml-1" style={{ fontSize: "0.7rem" }} />
											<Ink duration="500" />
										</DelayLink>
									</div>
								)}
							</div>
						)}
					</React.Fragment>
				)}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	restaurant_info: state.items.restaurant_info,
	cartProducts: state.cart.products,
	cartTotal: state.total.data,
	user: state.user.user,
	running_order: state.user.running_order,
	restaurant: state.restaurant,
	coupon: state.coupon.coupon,
	force_reload: state.helper.force_reload,
	tips: state.tips,
	tips_percentage: state.tips_percentage,
	confirmCart: state.confirmCart.confirmCart,
});

export default GoogleApiWrapper({
	apiKey: localStorage.getItem("googleApiKey"),
	LoadingContainer: Loading,
})(
	withRouter(connect(
		mapStateToProps,
		{
			checkUserRunningOrder,
			updateCart,
			getRestaurantInfoById,
			updateUserInfo,
			addProduct,
			checkCartItemsAvailability,
			checkBan,
			getRestaurantInfoAndOperationalStatus,
			removeCoupon,
		}
	)(Cart))
);
